import Colors from 'assets/Colors';

function NextArrowIcon({
  color = Colors.text_primary,
  size = '12',
  style = {},
}) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.1049 1.11298C3.13806 1.07717 3.17747 1.04875 3.22084 1.02937C3.26422 1.00998 3.31073 1 3.35769 1C3.40465 1 3.45116 1.00998 3.49454 1.02937C3.53791 1.04875 3.57732 1.07717 3.61048 1.11298L7.8951 5.72783C7.92835 5.76355 7.95473 5.80599 7.97273 5.85271C7.99073 5.89943 8 5.94952 8 6.0001C8 6.05069 7.99073 6.10077 7.97273 6.1475C7.95473 6.19422 7.92835 6.23666 7.8951 6.27238L3.61048 10.8872C3.54344 10.9594 3.4525 11 3.35769 11C3.26287 11 3.17194 10.9594 3.1049 10.8872C3.03785 10.815 3.00019 10.7171 3.00019 10.6149C3.00019 10.5128 3.03785 10.4149 3.1049 10.3427L7.13744 6.0001L3.1049 1.65753C3.07165 1.62181 3.04527 1.57937 3.02727 1.53265C3.00927 1.48593 3 1.43584 3 1.38526C3 1.33467 3.00927 1.28459 3.02727 1.23786C3.04527 1.19114 3.07165 1.14871 3.1049 1.11298Z"
        fill={color}
      />
      <path
        d="M3.1049 1.11298C3.13806 1.07717 3.17747 1.04875 3.22084 1.02937C3.26422 1.00998 3.31073 1 3.35769 1C3.40465 1 3.45116 1.00998 3.49454 1.02937C3.53791 1.04875 3.57732 1.07717 3.61048 1.11298L7.8951 5.72783C7.92835 5.76355 7.95473 5.80599 7.97273 5.85271C7.99073 5.89943 8 5.94952 8 6.0001C8 6.05069 7.99073 6.10077 7.97273 6.1475C7.95473 6.19422 7.92835 6.23666 7.8951 6.27238L3.61048 10.8872C3.54344 10.9594 3.4525 11 3.35769 11C3.26287 11 3.17194 10.9594 3.1049 10.8872C3.03785 10.815 3.00019 10.7171 3.00019 10.6149C3.00019 10.5128 3.03785 10.4149 3.1049 10.3427L7.13744 6.0001L3.1049 1.65753C3.07165 1.62181 3.04527 1.57937 3.02727 1.53265C3.00927 1.48593 3 1.43584 3 1.38526C3 1.33467 3.00927 1.28459 3.02727 1.23786C3.04527 1.19114 3.07165 1.14871 3.1049 1.11298Z"
        stroke={color}
      />
    </svg>
  );
}

export default NextArrowIcon;
